export default "__VITE_ASSET__36a5dec7__"